<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Currencies</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab dark color="primary" @click="createItem" class="ma-2">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Currency</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="currencies.edges"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
        >
          <template v-slot:item.actions="{item}">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>
      <v-card>
        <v-dialog v-model="currencyEditorDialog" persistent width="550">
          <v-card>
            <currency-editor
              :currency="selectedCurrency"
              :doSaveCurrency="doSaveCurrency"
              :currencyEditorDialog="currencyEditorDialog"
              @saved="onSaved($event)"
              @onResetSave="onResetSave"
            ></currency-editor>
            <v-card-actions class="grey lighten-3">
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
              <v-btn color="primary" @click="onSaveCurrency">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_CURRENCIES_SEARCH_QUERY,
  CURRENCY_DELETE_MUTATION
} from "../../../../constants/graphql";
import DefaultListActions from "../../shared/DefaultListActions";
import CurrencyEditor from "./CurrencyEditor";
import { pagingOptions } from "../../../../helpers/index";

export default {
  name: "CurrenciesList",

  components: {
    DefaultListActions,
    CurrencyEditor
  },

  data() {
    return {
      pagingOptions,
      search: "",
      currencies: {},
      selectedCurrency: {},
      currencyEditorDialog: false,
      doSaveCurrency: false,
      headers: [
        {
          text: "Name",
          value: "node.name",
          name: "name"
        },
        {
          text: "Code",
          value: "node.code",
          name: "code"
        },
        {
          text: "Symbol",
          value: "node.symbol",
          name: "symbol"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center"
        }
      ]
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    }
  },

  methods: {
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: CURRENCY_DELETE_MUTATION,
          variables: {
            currencyId: item.node.id
          }
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Currency removed." });
      if (this.$apollo.queries.currencies != null) {
        this.$apollo.queries.currencies.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error"
      });
    },
    editItem(item) {
      this.selectedCurrency = item.node;
      this.currencyEditorDialog = true;
    },
    createItem() {
      this.selectedCurrency = {};
      this.currencyEditorDialog = true;
    },
    onSaveCurrency() {
      this.doSaveCurrency = true;
    },
    onResetSave() {
      this.doSaveCurrency = false;
    },
    closeDialog() {
      this.currencyEditorDialog = false;
      this.selectedCurrency = {};
    },
    onSaved(context) {
      if (this.$apollo.queries.currencies != null) {
        this.$apollo.queries.currencies.refetch();
      }
      this.onResetSave();
      this.currencyEditorDialog = false;
      this.selectedCurrency = {};
      let msg = context == "edit" ? "Currency Updated." : "Currency Created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    }
  },

  apollo: {
    currencies: {
      query: ALL_CURRENCIES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {}
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/CurrenciesList.vue